export const LEARNING_GOAL_OPTIONS = {
  LEARNING_GOAL_LAND_NEW_JOB: 'LEARNING_GOAL_LAND_NEW_JOB',
  LEARNING_GOAL_CHANGE_CAREER: 'LEARNING_GOAL_CHANGE_CAREER',
  LEARNING_GOAL_IMPROVE_SKILLS: 'LEARNING_GOAL_IMPROVE_SKILLS',
  LEARNING_GOAL_PERSONAL_INTEREST: 'LEARNING_GOAL_PERSONAL_INTEREST',
} as const;

export type LEARNING_GOAL_OPTIONS_TYPE = (typeof LEARNING_GOAL_OPTIONS)[keyof typeof LEARNING_GOAL_OPTIONS];

export const EDUCATION_LEVEL_OPTIONS = {
  EDUCATION_LEVEL_LESS_THAN_HIGH_SCHOOL_DIPLOMA: 'EDUCATION_LEVEL_LESS_THAN_HIGH_SCHOOL_DIPLOMA',
  EDUCATION_LEVEL_HIGH_SCHOOL_DIPLOMA: 'EDUCATION_LEVEL_HIGH_SCHOOL_DIPLOMA',
  EDUCATION_LEVEL_COLLEGE_NO_DEGREE: 'EDUCATION_LEVEL_COLLEGE_NO_DEGREE',
  EDUCATION_LEVEL_ASSOCIATE_DEGREE: 'EDUCATION_LEVEL_ASSOCIATE_DEGREE',
  EDUCATION_LEVEL_BACHELOR_DEGREE: 'EDUCATION_LEVEL_BACHELOR_DEGREE',
  EDUCATION_LEVEL_MASTERS_DEGREE: 'EDUCATION_LEVEL_MASTERS_DEGREE',
  EDUCATION_LEVEL_PROFESSIONAL_DEGREE: 'EDUCATION_LEVEL_PROFESSIONAL_DEGREE',
  EDUCATION_LEVEL_DOCTORATE_DEGREE: 'EDUCATION_LEVEL_DOCTORATE_DEGREE',
} as const;

export type EDUCATION_LEVEL_OPTIONS_TYPE = (typeof EDUCATION_LEVEL_OPTIONS)[keyof typeof EDUCATION_LEVEL_OPTIONS];

export const ROLE_OPTIONS_TYPE = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM',
  UNSURE: 'UNSURE',
} as const;

export const SKILL_OPTIONS_TYPE = {
  DEFAULT: 'DEFAULT',
  UNSURE: 'UNSURE',
  RELATED: 'RELATED',
  CUSTOM: 'CUSTOM',
} as const;

export const PATHWAYS_ONBOARDING_EVENT_NAME = 'onboarding_pathways_multi_page';

export const ONBOARDING_V3_EVENT_NAME = 'onboarding_v3_personalized_multi_step';

export const PATHWAYS_ONBOARDING_MODULAR_EVENT_NAME = 'onboarding_pathways_modular';

export const CONVERSATIONAL_ONBOARDING_EVENT_NAME = 'onboarding_conversational';

export const CONVERSATIONAL_ONBOARDING_QUERY_PARAM = 'onboarding';

export const CONVERSATIONAL_ONBOARDING_PARAM_VALUES = {
  START: 'START',
  CHAT: 'CHAT',
  CPLUS: 'CPLUS',
} as const;

export type ConversationalOnboardingParamValue =
  (typeof CONVERSATIONAL_ONBOARDING_PARAM_VALUES)[keyof typeof CONVERSATIONAL_ONBOARDING_PARAM_VALUES];

export const ONBOARDING_BASE_URL = '/onboarding';

export const SKIP_ONBOARDING_QUERY_PARAM = 'skipOnboarding';

// Query param used to thread the enterprise org slug through the onboarding entry URL,
// so an enterprise learner can be resolved into their org context and redirected back to
// their org home on completion.
export const ORG_SLUG_QUERY_PARAM = 'orgSlug';

export const LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY = 'LOGGED_OUT_ONBOARDING_ANSWERS';

export const TOTAL_NUMBER_OF_SKILLS_TO_DISPLAY = 9;
export const DEFAULT_ROLE_OPTIONS_LIMIT = 8;
export const DEFAULT_SKILL_OPTIONS_LIMIT = 50;

export const LOGGED_OUT_ONBOARDING_COOKIE_NAME = 'logged_out_onboarding';

export const INPUT_TYPES = {
  USER_GENERATED: 'UserGenerated',
  DEFAULT: 'DefaultId',
};
